import * as React from "react";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import {HostedInstanceResource} from "client/resources/hostedInstanceResource";
import {HostedInstanceUsageMetricsResource} from "client/resources/hostedInstanceUsageMetricsResource";
import {HostedInstanceConfigureStorageRequest} from "client/resources/hostedInstanceConfigureStorageRequest";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import {Text} from "components/form";
import repository from "client/repository";
import {AreYouSureYouWantToIncreaseTheLimitCallout, ManualScalingCallout} from "./ManualScalingCallouts";

interface ChangeStorageQuotaDialogProps {
    instance: HostedInstanceResource;
    onSaved: (updatedInstance: HostedInstanceResource, updatedUsageMetrics: HostedInstanceUsageMetricsResource) => void;
}

interface ChangeStorageQuotaDialogState extends DataBaseComponentState {
    quotaInGb: number;
}

export class ChangeStorageQuotaDialog extends DataBaseComponent<ChangeStorageQuotaDialogProps, ChangeStorageQuotaDialogState> {
    constructor(props: ChangeStorageQuotaDialogProps) {
        super(props);
        this.state = {
            quotaInGb: props.instance.SharesQuotaInGb
        };
    }

    render() {
        return <SaveDialogLayout title={"Change storage quota in GB"}
                                 errors={this.state.errors}
                                 busy={this.state.busy}
                                 onSaveClick={() => this.configureStorage()}>

            <AreYouSureYouWantToIncreaseTheLimitCallout />
            <ManualScalingCallout />

            <Text label="Quota"
                  hintText="Storage quota for this Instance in GB"
                  value={this.state.quotaInGb.toString()}
                  onChange={quota => this.setState({quotaInGb: Number(quota)})}
                  autoFocus={true}
            />
        </SaveDialogLayout>;
    }

    private configureStorage() {
        return this.doBusyTask(async () => {
            const request: HostedInstanceConfigureStorageRequest = {SharedQuotaInGb: this.state.quotaInGb};
            const instance = await repository.HostedInstances.configureStorage(this.props.instance, request);
            const instanceUsageMetrics = await repository.HostedInstances.getUsage(instance.Id);
            this.props.onSaved(instance, instanceUsageMetrics);
            return true;
        });
    }
}
